module.exports = __webpack_public_path__ + "img/BG_Footer.86e4be76.png";